import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconRadioButtonActive = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_898_9974)">
        <circle cx="8" cy="8" r="7.5" stroke={theme.colors.text.primary} />
        <circle cx="8" cy="8" r="4" fill={theme.colors.text.primary} />
      </g>
      <defs>
        <clipPath id="clip0_898_9974">
          <rect width="16" height="16" fill={theme.colors.background.primary} />
        </clipPath>
      </defs>
    </IconBase>
  )
}
